import { useEffect, useRef } from 'react';

// Returns `value` while `isSettled`, otherwise holds the last settled value. Useful for
// derived values that go through transient intermediate states (e.g. mid-swap query windows)
// where re-rendering the live value would flash an incorrect result.
export const useHeldValue = <T>(value: T, isSettled: boolean): T => {
  const heldRef = useRef(value);

  useEffect(() => {
    if (isSettled) {
      heldRef.current = value;
    }
  }, [isSettled, value]);

  return isSettled ? value : heldRef.current;
};
